import AiCoachLauncher from 'app/modules/ai/components/AiCoachLauncher'
import {ThemeModeSwitcher} from '../../../partials'

const Topbar = () => {
  return (
    <div className='d-flex align-items-center flex-shrink-0 gap-3'>
      {/* AI Coach launcher: full pill on lg+, compact chip on smaller screens */}
      <div className='d-none d-lg-flex'>
        <AiCoachLauncher variant='pill' />
      </div>
      <div className='d-flex d-lg-none'>
        <AiCoachLauncher variant='chip' />
      </div>

      {/* begin::Theme mode */}
      <div className='d-flex align-items-center'>
        <ThemeModeSwitcher toggleBtnClass='btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px' />
      </div>
      {/* end::Theme mode */}
    </div>
  )
}

export {Topbar}
